import { render, staticRenderFns } from "./OrderErrorPopup.vue?vue&type=template&id=2186da5e&scoped=true"
import script from "./OrderErrorPopup.vue?vue&type=script&lang=js"
export * from "./OrderErrorPopup.vue?vue&type=script&lang=js"
import style0 from "./OrderErrorPopup.vue?vue&type=style&index=0&id=2186da5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2186da5e",
  null
  
)

export default component.exports